import { clusterApiUrl, Connection } from '@solana/web3.js'

export const solanaConnection = new Connection(
  process.env.NEXT_PUBLIC_ENVIRONMENT === 'production'
    ? 'https://withered-convincing-water.solana-mainnet.quiknode.pro/76f7977f2094f06f1ec57ce30a954e260b828963/'
    : clusterApiUrl('devnet')
)
// export const solanaConnection = new Connection('http://127.0.0.1:8899')
